import { compose } from "redux";
import component from "./index.component";
import container from "./index.container";
import withCurrentUser from "lib/containers/withCurrentUser";

export default compose(
  withCurrentUser,
  container
)(component);
